import { notification } from 'antd';
import EventService from './EventService';

/* Todo: implement more robust 'type' management of notifications, to be able to close them in group, ie. "All provider errors" */

class NotificationService {

    private notifications = [];

    public notifyInfo = (title, message, opts?) => {
        const key = `notification_${Date.now()}`;
        notification.info({
            key,
            message: title,
            description: message,
            onClose: opts?.onClose || (() => { }),
            onClick: opts?.onClick || (() => { }),
            duration: typeof opts?.duration != 'undefined' ? opts.duration : 5
        });
        this.notifications.push(key);
        return key;
    }

    public notifySuccess = (title, message, opts?) => {
        const key = `notification_${Date.now()}`;
        notification.success({
            key,
            message: title,
            description: message,
            onClose: opts?.onClose || (() => { }),
            onClick: opts?.onClick || (() => { }),
            duration: typeof opts?.duration != 'undefined' ? opts.duration : 5
        });
        this.notifications.push(key);
        return key;
    }

    public notifyError = (title, message, opts?) => {
        const key = `notification_${Date.now()}`;
        notification.error({
            key,
            message: title,
            description: message,
            onClose: opts?.onClose || (() => { }),
            onClick: opts?.onClick || (() => { }),
            duration: typeof opts?.duration != 'undefined' ? opts.duration : 5
        });
        this.notifications.push(key);
        return key;
    }

    public closeAllNotifications = () => {
        this.notifications.forEach(n => {
            notification.close(n);
        });
        this.notifications = [];
    }

}

export default new NotificationService();